import * as stylex from '@stylexjs/stylex';
import { styles } from './dot.styles';

// `ok` is `on`'s colour but ALWAYS pulses — for a summary indicator that must
// keep signalling "healthy" for as long as it stays healthy (e.g. a Faults
// tile), where `on` alone would read as static/inert next to `err`'s blink.
export type DotStatus = 'on' | 'off' | 'warn' | 'err' | 'ok';
interface DotProps {
  status?: DotStatus;
}
export function Dot({
  status = 'off'
}: DotProps) {
  return <span {...stylex.props(styles.base, styles[status])} />;
}